import beefSpicySubmarine from './Submarine/Beef Spicy Submarine.png'
import cheeseChickenSubmarine from './Submarine/Cheese Chicken Submarine.png'

let submarineItems = [
    {
        item_id: "30",
        item_name: "Beef Spicy Submarine",
        item_image: beefSpicySubmarine ,
        item_price:"2000",
        item_category: "submarine",
      },
      {
        item_id: "31",
        item_name: "Cheese Chicken Submarine",
        item_image:cheeseChickenSubmarine ,
        item_price:"2050",
        item_category: "submarine",
      },
]

export default submarineItems